import { createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
// import { push } from 'connected-react-router'

import i18n from 'i18n'
import { RestApiService } from '@/services'
import { ApplicationState } from '@/state/root.models'

import {
  setLoadingFullAction,
  setSnackbarAction,
} from '@/state/ui/global/slices/index.slices'
import { TwoFactorStatus } from '@/enums/two-factor-status.enum'
// import routes from '@/routes'

import { decodeJWT } from '@/utils'
import { getLoggedInUserThunk } from '@/state/auth/thunk/get-logged-in.thunk'
import ActionTypes from '../constants'

import { LoginPayload } from '../models'
import {
  loginActionSuccess,
  setTwoFactorPIDAction,
  setTwoFactorStatusAction,
  setUnauthorizedAction,
  setUserSessionAction,
} from '../slices/index.slices'

const apiService: RestApiService = Container.get(RestApiService)

const loginThunk = createAsyncThunk(
  ActionTypes.CHECK_TWO_FACTOR,
  async (payload: LoginPayload, thunkAPI) => {
    try {
      apiService.requestParams = {
        method: 'POST',
        endpoint: 'auth/login',
        body: {
          email: payload.searchParam,
          password: payload.password,
        },
      }

      const { auth } = thunkAPI.getState() as ApplicationState

      thunkAPI.dispatch(setLoadingFullAction(true))

      const response: any = await apiService.sendAuthData(auth.token || '')

      thunkAPI.dispatch(setLoadingFullAction(false))

      if (!response.accessToken) {
        if (response.twoFactorAuthActive) {
          thunkAPI.dispatch(setTwoFactorStatusAction(TwoFactorStatus.ACTIVE))
          thunkAPI.dispatch(setTwoFactorPIDAction(response.id))
        } else {
          thunkAPI.dispatch(
            setSnackbarAction({
              message:
                response.message || i18n.t('messages.invalidCredentials'),
              open: true,
              variant: 'error',
            }),
          )
        }
      } else {
        thunkAPI.dispatch(
          loginActionSuccess({
            accessToken: response.accessToken || '',
          }),
        )

        const { decoded, isValid } = decodeJWT(response.accessToken)

        if (isValid) {
          thunkAPI.dispatch(setUnauthorizedAction(true))
          thunkAPI.dispatch(setUserSessionAction(decoded))
          thunkAPI.dispatch(getLoggedInUserThunk())
          // TODO In the next implementations check this redirection
          // thunkAPI.dispatch(push(routes.HOME))
        }
      }
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue({
        message: error,
        status: error,
      })
    }
  },
)

export default loginThunk
